import React, { useContext, useEffect, useState } from "react";
import "./Withdrawal_History_List.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Select from "react-select";
import { Tabs, Tab, Button } from "react-bootstrap";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import Withdrawal_History_card from "../Withdraw/Withdrawal_History/Withdrawal_History_card/Withdrawal_History_card";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { GetAllWithdrawHistory } from "../../features/wallet/slice";
import { Context } from "../../utils/context";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";

function Withdrawal_History_List() {
  const [key, setKey] = useState("all");
  const [showDate, setShowDate] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedApp, setSelectedApp] = useState("All");
  const dispatch = useDispatch();
  const { signin } = useContext(Context);

  const withdrawHistory = useSelector((state) => state.wallet);

  const fetch = async (page) => {
    await dispatch(
      GetAllWithdrawHistory({
        page,
        startDate: selectedDate,
        status: selectedApp?.id,
      }),
    );
  };

  useEffect(() => {
    if (signin) fetch(1);
  }, [dispatch, signin, selectedDate, selectedApp]);

  const handlePageChange = async (page) => {
    fetch(page);
  };
  const options = [
    { label: "All", id: null },
    { label: "Pending", id: 1 }, // Processing
    { label: "Completed", id: 2 }, // Accepted
    { label: "Rejected", id: 3 },
  ];
  return (
    <>
      <section className="Withdrawal_History_List">
        <Common_white_header headingText={"Withdrawal History"} />

        <div className="container">
          {/* Payment Tabs */}
          {/* <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3 custom-tabs"
          >
            <Tab
              eventKey="all"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/select-all.png"
                    alt="peyment"
                    className="payment_method_img all_tab_payment_method_img"
                  />
                  All
                </>
              }
            />
            <Tab
              eventKey="upi"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/upi.png"
                    alt="peyment"
                    className="payment_method_img"
                  />{" "}
                  Phonepe/ Googlepay
                </>
              }
            />
            <Tab
              eventKey="phonepe"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/credit_card.png"
                    alt="peyment"
                    className="payment_method_img"
                  />{" "}
                  Bank Card
                </>
              }
            />
            <Tab
              eventKey="bank"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/usdt.png"
                    alt="peyment"
                    className="payment_method_img"
                  />{" "}
                  USDT
                </>
              }
            />
          </Tabs> */}

          {/* Filters Row */}
          <Filter_Drop
            options={options}
            showDate={showDate}
            setShowDate={setShowDate}
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedApp={selectedApp}
            setSelectedApp={setSelectedApp}
          />

          {/* Cards */}
          {withdrawHistory?.data?.length > 0 ? (
            <Withdrawal_History_card
              withdrawHistory={withdrawHistory}
              showQuery
            />
          ) : (
            <>
              <No_data />
              <button
                className="btn_details"
                onClick={() => {
                  setSelectedDate("");
                  setSelectedApp("");
                }}
              >
                Reset details
              </button>
            </>
          )}
        </div>

        {withdrawHistory?.total_pages > 1 && (
          <CustomPagination
            currentPage={withdrawHistory?.current_page}
            totalPages={withdrawHistory?.total_pages}
            handlePageChange={handlePageChange}
          />
        )}
      </section>
    </>
  );
}

export default Withdrawal_History_List;
